import { QuestionCircleOutlined } from '@ant-design/icons'
import { AuthTo } from '@common/Auth'
import { PRODUCT_EASY_CHAT } from '@constant'
import { HeaderView } from '@merchant-backend/common-components'
import { isUltimate } from '@merchant-backend/util'
import { observer } from 'mobx-react'
import React, { Component } from 'react'
import { Link } from 'react-router'
import IntroPage from './IntroPage'
import Setting from './Setting'
import Store from './store'

@AuthTo({ isAuthed: isUltimate, productId: PRODUCT_EASY_CHAT })
@observer
export default class extends Component {
  constructor(props) {
    super(props)

    this.store = new Store()
  }

  componentDidMount() {
    this.store.check()
    this.store.getTpl()
  }

  getHeader = () => (
    <div>
      轻松聊
      <Link to="/localMerchant/easyChat/help">
        <QuestionCircleOutlined style={{ color: '#ffbf00', marginLeft: 5 }} />
      </Link>
    </div>
  )

  render() {
    return (
      <HeaderView title={this.getHeader()}>
        {+this.store.active === 1 ? (
          <Setting store={this.store} />
        ) : (
          <IntroPage store={this.store} />
        )}
      </HeaderView>
    )
  }
}
